export const environment = {
  production: true,
  baseURL: 'https://dev.viveros.solidgear-projects.com/api/v1',
  sage: {
    active: true
  }
};
